import "./GetQuote.module.css";
import Header from "@/reusable_sections/Header";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function GetQuotePage() {
  return <div>
      <Header />
      <ContactUs />
      <Footer />
    </div>;
}